import { MatPaginatorIntl } from '@angular/material/paginator';
import { Router } from '@angular/router';

const matRangeLabelIntl = (page: number, pageSize: number, length: number) => {
	if (length === 0 || pageSize === 0) {
		return $localize`:@@hub.global.paginator-zero-range:0 sur ${length}`;
	}
	length = Math.max(length, 0);
	const startIndex = page * pageSize;

	// If the start index exceeds the list length, do not try and fix the end index to the end.
	const endIndex =
		startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
	return $localize`:@@hub.global.paginator-range-of-label:${startIndex + 1} - ${endIndex} sur ${length}`;
};

export function MyPaginatorIntl() {
	const paginatorIntl = new MatPaginatorIntl();

	paginatorIntl.itemsPerPageLabel = $localize`:@@hub.global.paginator-display-per-page:Éléments par page`;
	paginatorIntl.nextPageLabel = $localize`:@@hub.global.paginator-next-page:Page suivante`;
	paginatorIntl.previousPageLabel = $localize`:@@hub.global.paginator-prev-page:Page précédente`;
	paginatorIntl.getRangeLabel = matRangeLabelIntl;

	return paginatorIntl;
}

export function isActiveLink(
	router: Router,
	linkUrl: string,
	subLinks?: Array<{ url: string }>,
): boolean {
	const currentUrl = router.url.split('?')[0];

	if (
		subLinks?.some(
			subLink => currentUrl === subLink.url || currentUrl.startsWith(`${subLink.url}/`),
		)
	) {
		return true;
	}

	if (linkUrl === '/projects') {
		return (
			currentUrl === '/projects' ||
			(/^\/projects\/[^/]+$/.test(currentUrl) && !currentUrl.startsWith('/projects/flexo'))
		);
	}

	return currentUrl === linkUrl || currentUrl.startsWith(`${linkUrl}/`);
}
